module.exports = __webpack_public_path__ + "47fc1add/img/file-icon.c085e21e.svg";